import React, { useState } from 'react';

const TeamImage = ({ logo, flag, alt, className = 'w-12 h-12' }) => {
  const [imageError, setImageError] = useState(false);

  if (imageError || (!logo && !flag)) {
    return (
      <div className={`${className} rounded-lg bg-gray-200 border border-gray-300 flex items-center justify-center`}>
        <span className="text-gray-600 font-bold text-xl">
          {alt ? alt.charAt(0).toUpperCase() : '?'}
        </span>
      </div>
    );
  }

  return (
    <div className={`${className} relative rounded-lg overflow-hidden border border-gray-200 bg-white`}>
      {flag?.image && (
        <img
          src={flag.image}
          alt={alt}
          className="absolute inset-0 w-full h-full object-cover opacity-80"
          onError={() => setImageError(true)}
        />
      )}
      {logo && (
        <img
          src={logo}
          alt={alt}
          className="relative z-10 w-full h-full object-contain p-1"
          onError={() => setImageError(true)}
        />
      )}
    </div>
  );
};

export default TeamImage;
